import React from 'react';
import { Link } from 'react-router-dom';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const pieChart = (props) => {
    const colors = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#ea54e1'];

    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({
        cx, cy, midAngle, innerRadius, outerRadius, percent, index,
    }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text x={x} y={y + 10} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                {`${(percent * 100).toFixed(0)}%`}
            </text>
        );
    };

    return (
        <div>
            <h3 className="text-center">{props.title}</h3>
            <ul className="product-name-list">
                {
                    props.data.map((item, i) => {
                        return <li key={i} ><Link to={`/products/${item.id}`}><span style={{ backgroundColor: colors[i] }}></span>{item.name}</Link></li>
                    })
                }
            </ul>
            <ResponsiveContainer width="100%" height={320}>
                <PieChart>
                    <Pie
                        data={props.data}
                        cx="50%"
                        cy="40%"
                        labelLine={false}
                        label={renderCustomizedLabel}
                        // outerRadius={150}
                        fill="#8884d8"
                        dataKey="sold"
                        isAnimationActive={false}
                    >
                        {
                            props.data.map((entry, index) => <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />)
                        }
                    </Pie>
                    {/* <Legend verticalAlign="top"  height={36}/> */}
                </PieChart>
            </ResponsiveContainer>
        </div>

    );
}

export default pieChart;
